<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Reviews" subTitle="Superchargify automagically detects review apps that you are using for your store." />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Review app</h2>
        <p class="font-weight-normal mb-3">We currently support;</p>
        <div class="media mb-2 align-items-center" v-for="(x, rp) in reviewProviderMap" :key="rp">
          <IconCheck height="20" class="active no-primary ml-0 mr-2" />
          <div class="media-body font-weight-normal align-self-center">
            <p class="font-weight-normal mb-0">{{x}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card bs mb-4">
          <div class="card-body">
            <Alert icon="IconBolt" class="alert-info" v-if="review && plan === 'free' && review !== 'spr'">
              <p class="mb-0">Integration with {{reviewProviderMap[review]}} is available in Basic plan &amp; above.</p>
            </Alert>
            <label>Review apps available in your store<span v-if="review"> ({{reviewProviderCount}})</span></label>
            <select class="form-control" v-if="review" v-model="review">
              <option v-for="(obj, key) in vAuto.reviews" :key="'review:' + key" :value="key">{{reviewProviderMap[key]}}</option>
            </select>
            <Alert class="alert-danger mb-0" icon="IconImportant" v-else>
              <p class="mb-0">Your store either uses an unsupported review provider or doesn't have a review provider.</p>
            </Alert>
          </div>
        </div>
        <div class="card bs">
          <div class="card-body">
            <label>Refresh review app list</label>
            <div class="form-group font-weight-normal">
              <p class="mb-0">If you have added/removed a review app, please submit a request to refresh the settings for review apps.</p>
            </div>
            <ProcessButton type="reviews" successText="Your review providers are being refreshed." />
          </div>
        </div>
      </div>
    </div>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard class="text-right" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'
import ProcessButton from '@/components/ProcessButton'

import { reviewsMap } from '@/utils/reviews'

export default {
  mixins: [
    watchForChange(),
    mapMultiComputed('settings', [
      'review'
    ])
  ],
  components: {
    ProcessButton
  },
  computed: {
    ...mapState([ 'plan', 'vAuto' ]),
    reviewProviderCount: function () {
      if (!this.vAuto.reviews) return 0

      return Object.keys(this.vAuto.reviews).length
    },
    reviewProviderMap: function () {
      return reviewsMap
    }
  },
  methods: mapActions([ 'saveMaster' ])
}
</script>
